import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import StatusButton from '../StatusIndicators/StatusButton';

const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
`

const StatusButtonStyled = styled(StatusButton)`
  margin: 10px 10px 0 auto;
`

//TODO: create info card models
const MainCard = ({
  label,
	value,
	icon,
	customCode,
  onAlertClick,
  ...other
}) => {
	let valid = false;
	if(value) {
		valid = (value.primaryStatus === 'Valid')
	}
  return (
		<Container {...other}>
      {/* We don't have codes yet... <Label>Promotion Code: {customCode}</Label> */}
      {
        valid ? (
          <StatusButtonStyled value={value} validText="Live" {...other} />
        ) : value && <StatusButtonStyled value={value} invalidText="Off Air" {...other} />
      }
    </Container>
  )
}

MainCard.propTypes = {
  label: PropTypes.string,
  count: PropTypes.number,
	onAlertClick: PropTypes.func,
	value: PropTypes.object,
	customCode: PropTypes.string,
};

MainCard.defaultProps = {
	customCode: 'Betty Boop Rules!'
};

export default MainCard;
